import React from 'react';
import {Grid, Typography} from "@mui/material";
import {InvoiceCalculationResult} from "../../utils/InvoiceCalculator";
import {formatPrice} from "../../utils/NumberFormat";
import {Trans} from "react-i18next";

type CardProps = {
    calculationResult: InvoiceCalculationResult,
    currency: string,
}

export const InvoiceTotals = ({calculationResult, currency}: CardProps) => {
    return <>
        <Grid container spacing={1}>
            {
                [
                    {name: <Trans i18nKey="single_invoice.table.total_no_vat">Total excl. VAT</Trans>, value: calculationResult.totalExclVat},
                    {name: <Trans i18nKey="single_invoice.table.vat_total">Total VAT</Trans>, value: calculationResult.vatTotal},
                    {name: <Trans i18nKey="single_invoice.table.total">Invoice total</Trans>, value: calculationResult.total},
                ].map(({name, value}, index) => <React.Fragment key={index}>
                            <Grid item xs={2} style={{textAlign: "left"}}>
                            </Grid>
                            <Grid item xs={5} style={{textAlign: "left"}}>
                                <Typography variant={"subtitle2"}>{name}</Typography>
                            </Grid>
                            <Grid item xs={5} style={{textAlign: "right"}}>
                                <Typography variant={"subtitle2"}>{formatPrice(value, currency)}</Typography>
                            </Grid>
                        </React.Fragment>
                )
            }
        </Grid>
    </>
}
